module.exports = __webpack_public_path__ + "static/media/checkmark.30d2d34a.svg";